import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

<template>
  <div class="waze-wiki-badge" ...attributes>
    <div class="waze-wiki-badge-content">
      {{dIcon "w-doc"}}
      <wz-caption>{{i18n "waze.wiki.wiki_badge_text"}}</wz-caption>
    </div>
  </div>
</template>
